'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnSummaryBunja, getEarnSummaryOfCurrency } from '@flipster/features/src/shared/earn/state';
import { stack } from '@flipster/styled-system/patterns';
import { PusdtCurrency } from '@flipster/utils/constants/currency';

import { CurrencyHeader } from '../currency-header';
import { ActionButtons } from './components/action-buttons';
import { AprAppliedBalance } from './components/apr-applied-balance';
import { AprBreakdown } from './components/apr-breakdown';
import { AprDisplay } from './components/apr-display';
import { PendingReductions } from './components/pending-reductions';
import { ProcessingMintRequests } from './components/processing-mint-requests';
import { PusdtAutoConversionSection } from './components/pusdt-auto-conversion-section';
import { TotalBalance } from './components/total-balance';

export const ActiveAprCard = ({ currency }: { currency: string }) => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);

  const earnSummary = useAtomValue(earnSummaryAtom);

  const { appliedAprPct, pendingReductions, showAppliedBalanceDetail, processingMintRequests } =
    getEarnSummaryOfCurrency(currency, earnSummary);

  const showPendingReductions = pendingReductions.length > 0;
  const showProcessingMintRequests = processingMintRequests.length > 0;
  const showPusdtAutoConversionSection = currency === PusdtCurrency;

  return (
    <div className={stack({ rounded: 8, p: 16, bg: 'background.default.level-1', gap: 16 })}>
      <CurrencyHeader currency={currency} />
      <AprDisplay appliedAprPct={appliedAprPct} />
      <div className={stack()}>
        <TotalBalance currency={currency} />
        <AprBreakdown currency={currency} />
        {showAppliedBalanceDetail && <AprAppliedBalance currency={currency} />}
        {showPusdtAutoConversionSection && <PusdtAutoConversionSection />}
        {showPendingReductions && <PendingReductions currency={currency} />}
        {showProcessingMintRequests && <ProcessingMintRequests requests={processingMintRequests} />}
      </div>
      <ActionButtons currency={currency} />
    </div>
  );
};
